import fetch from 'auth/FetchInterceptor'

const feedbackService = {}

feedbackService.enviar = function (formData) {
  return fetch({
    url: '/feedback',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export default feedbackService
